import { Route, Switch } from 'react-router-dom'
import NotFoundPage from '../404/NotFoundPage'
import DefaultAdminScreen from '../default/DefaultAdminScreen'
import { ROUTER_PATH } from './metaData'
import ProfileScreen from '../profile'
import ProductsManagement from '../products'
import OrderManagement from '../order'
import OrderManagementScan from '../order_scan'
import ReportManagement from '../report'
import WarehouseManagement from '../warehouse-management'
import SellerManagement from '../seller-management'
import FulfillmentManagement from '../fulfillment-management'
import TagManagement from '../tag-management'
import ListProductsManagement from '../products/ListProducts'
import ListProductsGroupManagement from '../productGroup/index'
import FundManagement from '../fund-management'
import SupplierManagement from '../supplier-management'
import PriceManagement from '../price-management'
import IntroPage from '../Intro/Intro'
import AccountManagement from '../account-management'
import ConfigManagement from '../config-management'
import SkuManagementScreen from '../sku-management'
import ShippingManagementScreen from '../shipping-management'
import ShipManagementScreen from '../ship-management'
import WhitelistManagement from '../whitelist-management'
import NotificationManagement from '../notification-management'
import ServiceManagement from '../service-management'
import TwoFactorSetup from '../two-factor-setup'
const AdminRouters = (props: any) => {
   return (
      <Switch>
         <Route exact path={`/`} component={DefaultAdminScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.IntroPage}`} component={IntroPage} />

         <Route exact path={`${props.match.url}${ROUTER_PATH.ConfigManagementScreen}`} component={ConfigManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.SellerManagementScreen}`} component={SellerManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.SupplierManagement}`} component={SupplierManagement} />
         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.FulfillmentManagementScreen}`}
            component={FulfillmentManagement}
         />
         <Route exact path={`${props.match.url}${ROUTER_PATH.TagManagementScreen}`} component={TagManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.PriceManagement}`} component={PriceManagement} />

         <Route exact path={`${props.match.url}${ROUTER_PATH.AccountManagementScreen}`} component={AccountManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProfileScreen}`} component={ProfileScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProductsManagement}`} component={ProductsManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.OrderManagement}`} component={OrderManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.OrderScanManagement}`} component={OrderManagementScan} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ReportManagement}`} component={ReportManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.WarehouseManagement}`} component={WarehouseManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.FundManagement}`} component={FundManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.SkuManagementScreen}`} component={SkuManagementScreen} />
         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.ShippingManagementScreen}`}
            component={ShippingManagementScreen}
         />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ShipManagementScreen}`} component={ShipManagementScreen} />
         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.WhitelistManagementScreen}`}
            component={WhitelistManagement}
         />

         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.NotificationManagement}`}
            component={NotificationManagement}
         />

         <Route exact path={`${props.match.url}${ROUTER_PATH.ServiceManagement}`} component={ServiceManagement} />

         <Route exact path={`${props.match.url}${ROUTER_PATH.TwoFactorSetup}`} component={TwoFactorSetup} />

         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.ListProductsManagement}`}
            component={ListProductsManagement}
         />

         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.ListProductsGroupManagement}`}
            component={ListProductsGroupManagement}
         />

         <Route path="*" component={NotFoundPage} />
      </Switch>
   )
}

export default AdminRouters
